<template>
  <div class="profile">
    <h4 style="text-align: center;">金螳螂公益慈善基金会简介</h4>
    <p>2015年3月，通过全员募捐、公司捐款和金螳螂控股朱兴良董事长个人捐赠形式募集善款，金螳螂公益慈善基金会在苏州市民政局注册成立，原始注册资金5000万元，成为苏州较大规模的非公募公益基金会。2017年6月，金螳螂公益慈善基金会成为苏州首家被认定的“慈善组织”，2017年11月，被评为4A级社会组织，2018年9月，荣获第三届苏州慈善奖“最具影响力慈善组织”，同年，金螳螂集团荣获第四届江苏慈善奖“最具爱心捐赠单位”，2019年荣获江苏省“慈善之星”。</p>
    <div class="img">
      <img src="../../assets/p1.png"/>
      <img src="../../assets/zs-1.png"/>
    </div>
    <p>金螳螂公益慈善基金会成立后，通过系统的梳理逐步形成了:一个平台,六大模块,两支队伍。在金螳螂公益慈善基金会这一平台上开展了涉及“教育、医疗、养老、助残、扶贫、环保”六大模块的十多个长期公益项目，救助帮扶万余人。集合金螳螂在职员工和合作伙伴的公益力量组建了两支志愿服务队伍,注册人数达千余人,从慰问孤寡老人、残疾儿童、山区退伍军人,到无偿献血、公益送教,累计服务时长超万。</p>
    <p>在苏州市社会组织党委下成立了第一家基金会的党支部，将党建与慈善公益充分融合，创新出具有自己特色的党建项目，为慈善公益事业奉献自己的一份力量。</p>
  </div>
</template>

<script>

export default {
  name: 'profile',
  components: {
  }
}
</script>